import React from "react";

export function Spacer(props: { height?: string }) {
  return <div style={{ height: props.height || "0.5em" }}>&nbsp;</div>;
}
